export const initialState = {
  isSubscribed: false
}
